export const projectsList = [
    {
      title: "Renu Looks(Beauty Services)",
      description: "we created friendly beauty parlour website",
      link: "https://www.renulooks.in/",
      image: "/projects/project1.png",
    },

    {
      title: "Quick Driver",
      description: "Q-Drive is an on-demand platform connecting car owners with professional drivers for a hassle-free driving experience.",
      link: "https://qdrive.srtechcreators.com/",
      image: "/projects/project2.png",
    },
    {
      title: "Pet Cremation Services Vijayawada",
      description: "Providing compassionate and dignified pet cremation and burial services to honor your beloved companions.",
      link: "https://www.petburialvijayawada.com/",
      image: "/projects/project3.jpeg",
    },
  ];